// removed by extract-text-webpack-plugin
module.exports = {"Burger":"Burger__Burger__3K4F-","CheckoutBurger":"Burger__CheckoutBurger__2L0is","burgerFillerText":"Burger__burgerFillerText__21rta"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/Burger.css
// module id = 138
// module chunks = 0